import Api from '../../api'
import axios from '@/js/api'
// import { Message }from 'element-ui'
import router from '../../router'
import breadcrumb from './breadcrumb.js'
import date from '../../js/date.js'
// //设置日期
// function dataNumbers(day){
//     let today = new Date();
//     let targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
//     today.setTime(targetday_milliseconds); 
//     let tYear = today.getFullYear();
//     let tMonth = today.getMonth();
//     let tDate = today.getDate();
//     return tYear+"-"+parseInt(tMonth+1)+"-"+tDate;
// }
// //获取具体日期
// function dataNumber(day){
//     let today = new Date(day);
//     let tYear = today.getFullYear();
//     let tMonth = today.getMonth();
//     let tDate = today.getDate();
//     return tYear+"-"+parseInt(tMonth+1)+"-"+tDate;
// }

// let startDate=dataNumbers(-360)
// let endDate=dataNumbers(0)
const state ={
    scoreitemParameter:{
        type: '0',
        mode: '0',
        enable: '-1',
        name: '',
        keyWord:'',
        modalityType: '',
        ScoreItemType: 0,
        pageCount: 10,
        pageIndex: 1,
        ScoreItemType: 0,
		IsSpecial:''
    },
   
    globleDate:{
        startDate:'', //开始时间
        endDate:'', //结束时间
    },
    pickerDate:{
        date:[]
    },
    isscreen:{
        scheme:false,
        rules:false,
    },
    scoreitemList:[],//评分细则
    qcplanList:[],//评分方案
    total:0,
    ReportIds:[],
    splitScreen:false,
    detailsRulesParameter:breadcrumb.state.detailsRulesParameter,
    //新建评分细则
    rulesFrom:{
		IsSpecial:false,
        uniqueId: "",
        type: '',//类型
        mode: '',//模式
        score: '',//分值
        Enable: true,//是否启用
        modalityType: '',//设备
        category: "",//类别
        description: "",//描述
        remark: "",//备注
        OptionList: [{
            OptionGuid:"",
            Description:"",
            Score:0,
            Remark: "",
            localityid:1
        }],
        HasOption: false,//细则选项
        SeriousScore: 0,//严重扣分
        },
        //删除评分细则
        scoreitemDeleteId:{
            UniqueId:''
        },
        //删除评分方案
        QCPlanGuidId:{
            UniqueId:''
        },
        //新建评分方案
        schemeFrom:{
            UniqueId: "",
            Name: "",
            Type: '',
            Mode: '',
            Enable: true,
            Creator: "",
            Mender: "",
            ScoreItemList: [],
            ModalityType: [],
            ScoreItemType:1
        },
        //评分方案弹窗
        newSchemeDetailsListReport:[],
        newSchemeDetailsImgReport:[],
        newSchemeDetailsHistoryReport:[],   //病史细则
        newreportSpecialSIList:[],
        newSchemeReportList:[],
        newSchemeImgtList:[],
        newSchemeHistoryList:[],
        newSpecialSIList:[],
        setdialogVisible:{
            dialogVisible:false,
        },
		loading:false,
		dictionaryList:[],
		isSpecialType:{
			type:false
		}
};
const getters={
 
};
const mutations={
	setReportModality(state, res){
        state.detailsRulesParameter.modalityType = res.data.Data;
		state.detailsRulesParameter.modalityType.forEach(item=>{
			item.text = item.Name;
		})
	},
	//loading
	setLoading(state,arr){
        state.loading=arr;
    },
    //初始化参数
    clearInit(state){
        state.scoreitemParameter.pageIndex=1;
        state.scoreitemParameter.name=''
        state.scoreitemParameter.keyWord=''
        state.scoreitemParameter.type='0'
        state.scoreitemParameter.enable='-1'
        state.scoreitemParameter.modalityType=''
        state.globleDate.startDate=''
        state.globleDate.endDate=''
        state.pickerDate.date=[];
        state.splitScreen=false;
        
       
    },
    //导航显示内容
    setIsscreen(state,arr){
        state.isscreen.scheme=false;
        state.isscreen.rules=false;

        if(arr=='scheme'){
            state.isscreen.scheme=true;
        }
        if(arr=='rules'){
            state.isscreen.rules=true;
        }
    },
    //初始化评分方案
    clearQCPlan(state){
        state.schemeFrom={
            UniqueId: "",
            Name: "",
            Type: '',
            Mode: '',
            Enable: true,
            Creator: "",
            Mender: "",
            ScoreItemList: [],
            ModalityType: [],
            ScoreItemType:0,
        }
        state.newSchemeImgtList = [];
        state.newSchemeReportList = [];
        state.newSpecialSIList = [];
        state.newSchemeHistoryList = [];
    },
    //初始化评分细则表单
    clearRulesFrom(state){
        state.rulesFrom={
			IsSpecial:false,
            uniqueId: "",
            type: '',//类型
            mode: '',//模式
            score: '',//分值
            Enable: true,//是否启用
            modalityType: [],//设备
            category: "",//类别
            description: "",//描述
            remark: "",//备注
            OptionList: [{
                OptionGuid:"",
                Description:"",
                Score:0,
                Remark: "",
                localityid:1
            }],
            HasOption: true,//细则选项
            SeriousScore: 0,//严重扣分
            }
    },
    setRulesFrom(state,arr){
     	
       let Enable=arr.Enable==1?true:false
        state.rulesFrom={
			IsSpecial:arr.IsSpecial,
            uniqueId: arr.ScoreItemGuid,
            type:arr.Type,//类型
            mode: arr.Mode,//模式
            score: arr.Score,//分值
            Enable: Enable,//是否启用
            modalityType: arr.ModalityType.split(','),//设备
            category: arr.Category,//类别
            description: arr.Description,//描述
            remark: arr.Remark,//备注
            OptionList: arr.OptionList,
            HasOption: arr.HasOption,//细则选项
            SeriousScore: arr.SeriousScore,//严重扣分
			CategoryId:arr.CategoryId,
            edit:true
            }

    },
    
    //评分细则
    setScoreitem(state,arr){    
        state.scoreitemList=arr.data.ScoreItems;
        state.total=arr.data.TotalCount;
		if (state.isSpecialType.type) {
			state.newreportSpecialSIList=arr.data.ScoreItems;
		}
		if (!state.isSpecialType.type&&arr) {
            state.newSchemeDetailsImgReport=arr.data.ScoreItems.filter(res=>{
                return res.Type==1
            })
            state.newSchemeDetailsListReport=arr.data.ScoreItems.filter(res=>{
                return res.Type==2
            }) 
            state.newSchemeDetailsHistoryReport=arr.data.ScoreItems.filter(res=>{
                return res.Type==3
            })
        }
       
        
    },
    //评分方案-普通细则-新
    setScoreitemNew(state,arr){    
        state.scoreitemList=arr.data.ScoreItems;
        state.total=arr.data.TotalCount;
        console.log(state.isSpecialType.type, 'state.isSpecialType.type');
        console.log(arr, 'state.isSpecialType.type');
		if (state.isSpecialType.type) {
			state.newreportSpecialSIList=arr.data.ScoreItems;
		}
		if (!state.isSpecialType.type&&arr) {
            state.newSchemeDetailsImgReport=arr.data.ScoreItems.filter(res=>{
                return res.Type==1
            })
            state.newSchemeDetailsListReport=arr.data.ScoreItems.filter(res=>{
                return res.Type==2
            }) 
            state.newSchemeDetailsHistoryReport=arr.data.ScoreItems.filter(res=>{
                return res.Type==3
            })
        }
       
        
    },
    //评分方案
    setQcplan(state,arr){
        state.qcplanList=arr.data.QCPlans;
       
        state.total=arr.data.TotalCount;
    },
    currentChanges(state,val){
        state.scoreitemParameter.pageIndex=val
        
    },
    setDatePicker(state,val){
        if(val){
            state.globleDate.startDate=date.dataNumber(val[0]);
            state.globleDate.endDate=date.dataNumber(val[1]);
        }
        else{
            state.globleDate.startDate='';
            state.globleDate.endDate='';
        }
       
        
    },
    setDatePickerDetails(state,val){
        state.globleDate.startDate='';
        state.globleDate.endDate='';
        
    },
    
    // setDoctorStatus(state,val){
    //     state.listParameter.status=val
    // },
    
    //分屏
    setSplitScreen(state,arr){
        state.splitScreen=arr;
        state.loading=false;
    },
    //评分细则筛选
    setSchemeScoreitemParameter(state,arr){
        
        state.scoreitemParameter.type=state.schemeFrom.Type;
        let Enable=state.schemeFrom.Enable?1:0;
        let ModalityType=[]
        let modalityTypeFilter=state.detailsRulesParameter.modalityTypeFilter.filter((res)=>{
          
         for(let i=0;i<state.schemeFrom.ModalityType.length;i++){
             if(res.text==state.schemeFrom.ModalityType[i]){
                 return res
             }
         }       
            
        })
        modalityTypeFilter.map(res=>{
         ModalityType.push(res.text)
        })  
            state.scoreitemParameter.modalityType=ModalityType.join(',');
            state.scoreitemParameter.ScoreItemType=state.schemeFrom.ScoreItemType;
            state.scoreitemParameter.mode=state.schemeFrom.Mode;
            state.scoreitemParameter.enable=1;
            state.scoreitemParameter.pageIndex=1;
            state.scoreitemParameter.pageCount=1000;
    },
    //修改评分细则
    ModifySchemeFrom(state,arr){
        let arrs=arr.data.Plan
        if(arr.data.code==200){
            
            if(arrs.Enable==1){
                state.schemeFrom.Enable=true
            }
            else{
                state.schemeFrom.Enable=false
            }
            state.schemeFrom.UniqueId=arrs.QCPlanGuid;
            state.schemeFrom.Name=arrs.Name;
            state.schemeFrom.Type=arrs.Type;
            state.schemeFrom.Creator=arrs.Creator;
            state.schemeFrom.Mender=arrs.Mender;
            state.schemeFrom.ScoreItemType=arrs.ScoreItemType;
            state.schemeFrom.Mode=arrs.Mode;
            state.schemeFrom.ModalityType=arrs.ModalityType.split(',');
            if(arrs.ScoreItemList.length>0){
                state.newSchemeImgtList=arrs.ScoreItemList.filter(res=>{
                    return res.Type==1
                })
                state.newSchemeReportList=arrs.ScoreItemList.filter(res=>{
                    return res.Type==2
                })
                state.newSchemeHistoryList=arrs.ScoreItemList.filter(res=>{
                    return res.Type==3
                })
            }
			state.newSpecialSIList = arrs.SpecialItemList;

        }
       
    },

    clearSetSchemeScoreitemParameter(state){
     
        state.scoreitemParameter.type=0;
        state.scoreitemParameter.modalityType=[];
            
        state.scoreitemParameter.ScoreItemType=0;
        state.scoreitemParameter.mode=0;
      
        state.scoreitemParameter.enable=-1;
        state.scoreitemParameter.pageIndex=1;
        state.scoreitemParameter.pageCount=10;
    },
    //选择评分细则
    setNewSchemeImgReporttList(state,arr){
       
        if(arr.type=='img'){
            state.newSchemeImgtList=arr.data
        }
        if(arr.type=='report'){
            state.newSchemeReportList=arr.data
        }
        if(arr.type=='history'){
            state.newSchemeHistoryList=arr.data
        }
        if(arr.type=='special'){
            state.newSpecialSIList=arr.data
        }
        // state.newSchemeImgtList.map(res=>{
        //     res.Sort=0;
        // })
        // state.newSchemeReportList.map(res=>{
        //     res.Sort=0;
        // })
        // state.newSpecialSIList.map(res=>{
        //     res.Sort=0;
        // })
    },
   setDictionary(state,res){
	   state.dictionaryList = res.data.Dictioaries[0].Values;
   }

   
    
};
const actions={
    //设备类型
    GetReportModality({
        state,
        commit,
        dispatch
    },arr) {
        axios.ajaxGet('get', Api.api.manager.GetReportModality).then(res => {
            if(res.data.StatusCode){
                commit('setReportModality', res);
            }
        })
    },
    //评分细则
    scoreitem({commit,state}){
		commit('setLoading',true)
        state.scoreitemParameter.startDate=state.globleDate.startDate;
        state.scoreitemParameter.endDate=state.globleDate.endDate;
       
        return axios.ajaxGet('get',Api.api.manager.scoreitem,state.scoreitemParameter).then(res=>{
           commit('setScoreitem',res)
           commit('setLoading',false)
        }).finally(() => {});
    },
    //评分细则
    scoreitemNew({commit,state}){
        commit('setLoading',true)
        state.scoreitemParameter.startDate=state.globleDate.startDate;
        state.scoreitemParameter.endDate=state.globleDate.endDate;
        return axios.ajaxGet('get',Api.api.manager.scoreitemNew,state.scoreitemParameter).then(res=>{
            commit('setScoreitemNew',res)
            commit('setLoading',false)
        }).finally(() => {});
    },
    clearScoreItem({commit,state}){

    },
    //评分方案
    qcplan({commit,state}){

		commit('setLoading',true)
        state.scoreitemParameter.startDate=state.globleDate.startDate;
        state.scoreitemParameter.endDate=state.globleDate.endDate;
       
        axios.ajaxGet('get',Api.api.manager.qcplan,state.scoreitemParameter).then(res=>{
           commit('setQcplan',res);
           commit('setLoading',false)
        })
    },
    //评分细则添加
    createorupdate({commit,state,dispatch}){
        state.rulesFrom.OptionList.forEach((item,index) => {
            item.AddSort = index
        });
 //       console.log(state.rulesFrom.OptionList);
       if(state.rulesFrom.Enable){
        state.rulesFrom.Enable=1;
       }
       else{
        state.rulesFrom.Enable=0;
       }
    //    let modalityType=[]
    //    let modalityTypeFilter=state.detailsRulesParameter.modalityTypeFilter.filter((res)=>{
          
    //     for(let i=0;i<state.rulesFrom.modalityType.length;i++){
    //         if(res.text==state.rulesFrom.modalityType[i]){
    //             return res
    //         }
    //     }       
           
    //    })
    //    console.log(state.detailsRulesParameter.modalityTypeFilter, 'modalityTypeFilter');
    //    console.log(state.rulesFrom.modalityType, 'state.rulesFrom.modalityType');

    //    modalityTypeFilter.map(res=>{
    //       modalityType.push(res.text)
    //    })      
		state.rulesFrom.modalityType=state.rulesFrom.modalityType.filter(item=>{
            return item!==''
        });
		state.rulesFrom.mode = state.rulesFrom.mode || 2;
        axios.ajaxPost('post',Api.api.manager.createorupdate,state.rulesFrom).then(res=>{
          if(res.data.code=200){
            dispatch('scoreitem')
            commit('setSplitScreen',false)
            commit('setLoading',false)
            ELEMENT.Message.success(res.data.Msg)
            router.go(-1);
          }
          else{
           
          }
          // commit('clearRulesFrom');
        })
    },
    //删除评分细则
    scoreitemDelete({commit,dispatch,state}){
        axios.ajaxPost('post',Api.api.manager.scoreitemDelete,state.scoreitemDeleteId).then(res=>{
            if(res.data.code=200){
              dispatch('scoreitem')
              commit('setLoading',false)
              ELEMENT.Message.success(res.data.Msg)
            }
          })
    },

     //评分方案
     createorupdateQcplan({commit,state,dispatch}){

        if(state.schemeFrom.Enable){
         state.schemeFrom.Enable=1;
        }
        else{
         state.schemeFrom.Enable=0;
        }
        let ModalityType=[]
       let modalityTypeFilter=state.detailsRulesParameter.modalityTypeFilter.filter((res)=>{
         
        for(let i=0;i<state.schemeFrom.ModalityType.length;i++){
            if(res.text==state.schemeFrom.ModalityType[i]){
                return res
            }
        }       
           
       })
       modalityTypeFilter.map(res=>{
        ModalityType.push(res.text)
       })  
     
       state.schemeFrom.ModalityType=ModalityType;
        let ScoreItemList=[...state.newSchemeImgtList,...state.newSchemeReportList,...state.newSpecialSIList,...state.newSchemeHistoryList];
        state.schemeFrom.ScoreItemList=ScoreItemList
         axios.ajaxPost('post',Api.api.manager.createorupdateQcplan,state.schemeFrom).then(res=>{
           if(res.data.code=200){
             dispatch('qcplan')
             commit('setSplitScreen',false)
             commit('setLoading',false)
             ELEMENT.Message.success(res.data.Msg)
             router.go(-1);
           }
           else{
            
           }
            
           
         })
     },
      //删除评分方案
      DeleteQCPlan({commit,dispatch,state}){
        axios.ajaxPost('post',Api.api.manager.DeleteQCPlan,state.QCPlanGuidId).then(res=>{
            if(res.data.code=200){
              dispatch('qcplan')
              commit('setLoading',false)
              ELEMENT.Message.success(res.data.Msg)
            }
          })
    },
    //修改评分方案
    GetQCPlan({commit,state}){
        axios.ajaxGet('get',Api.api.manager.GetQCPlan+'/'+state.QCPlanGuidId.QCPlanGuid).then(res=>{
            if(res.data.code=200){
                commit('ModifySchemeFrom',res)
                commit('setLoading',false)
            //   dispatch('qcplan')
            //   ElementUI.Message.success(res.data.Msg)
            }
          })
    },
    //获取字典
    GetDictionary({commit,state},arr){
        axios.ajaxGet('get',Api.api.manager.GetDictionary,arr).then(res=>{
            if(res.data.code=200){
                commit('setDictionary',res)
            }
          })
    },
   
    
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
